export enum UserField {
  AVATAR_PNG = 'avatarPngUrl',
  AVATAR_GLB = 'avatarUrl',
  BIRTH_YEAR = 'birthYear',
  COUNTRY = 'country',
  CURRICULUM = 'curriculum',
  COUNTRY_CALLING_CODE = 'countryCallingCode',
  COUNTRY_CODE = 'countryCode',
  EMAIL = 'email',
  FACEBOOK_EMAIL = 'facebookEmail',
  FULL_NAME = 'fullName',
  GRADE_LEVEL_ID = 'gradeLevelId',
  NICKNAME = 'nickname',
  PASSWORD = 'password',
  PASSWORD_CONFIRM = 'passwordConfirm',
  PHONE = 'phone',
  SKILL = 'skill',
  TYPE = 'userType',
  AUTH_EMAIL = 'authEmail',
  WANTS_NEWSLETTER = 'wantsNewsletter',
  YEARS_IN_SCHOOL = 'yearsInSchool',
  TIMEZONE = 'timezone',
  IS_TEACHER = 'isTeacher',
}
